const documentId = `
  ${process.env.GATSBY_STRAPI_VERSION === '5' ? 'documentId' : ''}
`;

export default `
  fragment VehiclePreview on VehiclesVehicle {
    ${documentId}
    slug
    name
    make
    model
    type
    lowestPrice
    regularPrice
    isSold
    odometer
    fuel
    buildyear
    baseColor
    image {
      data {
        id
        attributes {
          url
          height
          width
          overlay {
            data {
              id
              attributes {
                url
                height
                width
              }
            }
          }
        }
      }
    }
    taxType
    regularPriceExBtw
    externalLeases {
      data {
        id
        attributes {
          price
          vdp {
            data {
              id
              ${documentId}
            }
          }
        }
      }
    }

    # private lease
    leases {
      data {
        id
        attributes {
          maandbedrag
        }
      }
    }

    # 24 months warranty is based on:
    customWarranty
  }
`;
